<template>
    <div class="btn btn-with-gallery-filter py-0" :class="{'btn-with-gallery-filter--active': searchOnlySexChat}">
        {{ translate.home.sexChat }}
    </div>
</template>

<script>
function searchOnlySexChat() {
    return _.get(this, 'extraContent.sexChat');
}

export default {
    computed: {
        ...mapState(['translate', 'extraContent']),
        searchOnlySexChat,
    },
}
</script>
